/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="Group_3023" data-name="Group 3023" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24.05" height="24" viewBox="0 0 24.05 24">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_701" data-name="Rectangle 701" width="100%" height="100%" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="Group_3022" data-name="Group 3022" transform="translate(0 0)" clip-path="url(#clip-path)">
    <path id="Path_1774" data-name="Path 1774" d="M.03,23.189c.072-.288.181-.727.292-1.166q1.2-4.717,2.405-9.432a2.044,2.044,0,0,0,.014-1.076C1.926,8.375,1.134,5.228.334,2.084.24,1.716.128,1.353.046.983A.737.737,0,0,1,.239.142a.83.83,0,0,1,.928,0C2.5.816,3.836,1.5,5.174,2.168q4.99,2.5,9.985,4.987,4.073,2.036,8.142,4.077a3.755,3.755,0,0,1,.524.351A.7.7,0,0,1,23.7,12.7c-1.962.954-3.9,1.952-5.854,2.929q-3.393,1.7-6.79,3.391-4.469,2.233-8.936,4.47A5.834,5.834,0,0,1,1.3,23.9a2.153,2.153,0,0,1-.851.09c-.3-.032-.443-.3-.422-.8M21.8,12.081c0-.036,0-.073,0-.11L1.79,1.962l-.081.084c.064.217.136.431.191.65q1.051,4.2,2.093,8.4c.047.192.121.252.319.252q4.987-.01,9.975,0a4.881,4.881,0,0,1,.693.045.713.713,0,0,1,.611.629.683.683,0,0,1-.587.648,6.968,6.968,0,0,1-.947.048q-4.86,0-9.721,0c-.176,0-.285.015-.337.225Q2.955,17.171,1.892,21.4c-.052.208-.118.413-.178.62l.079.066L21.8,12.081" transform="translate(0 0)" fill="#fff"/>
  </g>
</svg>
`

const SendMessageSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default SendMessageSvg
